// This file contains a set of constants describing common error scenarios.
// Remember that these errors will be returned to the 3P host, so they should
// not contain any customer content or intricate details of our implementation.

import type { ErrorInfo } from "./type";
import { ErrorType } from "./type";
import type { ErrorType as OWLErrorType } from "@1js/owlet-sdk";

export const AppLoadTimeout: ErrorInfo = {
  errorName: "AppLoadTimeout",
  errorType: ErrorType.Transient,
  errorMessage: "Timeout waiting for app to load",
};

export const AppLoadFailedUnexpected: ErrorInfo = {
  errorName: "AppLoadFailed",
  errorType: ErrorType.Unexpected,
  errorMessage: "Failed to load app",
};

export const DocumentAPINotInitialized: ErrorInfo = {
  errorName: "DocumentAPINotInitialized",
  errorType: ErrorType.BadRequest,
  errorMessage: "Document API must be initialized before use",
};

export const MeetingAPINotInitialized: ErrorInfo = {
  errorName: "MeetingAPINotInitialized",
  errorType: ErrorType.BadRequest,
  errorMessage: "Meeting API must be initialized before use",
};

export const InvalidInputParameters: ErrorInfo = {
  errorName: "InvalidInputParameters",
  errorType: ErrorType.BadRequest,
  errorMessage: "Invalid parameters",
};

export const PresentationInProgress: ErrorInfo = {
  errorName: "PresentationInProgress",
  errorType: ErrorType.BadRequest,
  errorMessage:
    "StopPresentation must be called before a new presentation is launched",
};

export function getErrorTypeFromOWLErrorType(
  err: OWLErrorType | undefined
): ErrorType {
  if (err) {
    switch (err) {
      case "NetworkError":
        return ErrorType.Transient;
      case "HttpError":
        return ErrorType.Unexpected;
      case "AuthError":
        return ErrorType.Unauthorized;
      case "InlineFrameScriptError":
        return ErrorType.Unexpected;
      case "Timeout":
        return ErrorType.Transient;
      case "ExpectedFailure":
        return ErrorType.NotSupported;
      default:
        return ErrorType.Unexpected;
    }
  } else {
    return ErrorType.Unexpected;
  }
}
